import { render } from "./manualExtension.vue?vue&type=template&id=3fe1e9ac&scoped=true"
import script from "./manualExtension.vue?vue&type=script&lang=js"
export * from "./manualExtension.vue?vue&type=script&lang=js"

import "./manualExtension.vue?vue&type=style&index=0&id=3fe1e9ac&lang=scss&scoped=true"
import "./manualExtension.vue?vue&type=style&index=1&id=3fe1e9ac&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe1e9ac"]])

export default __exports__